import React, { useContext, useReducer } from 'react';
import { initialState, AuthReducer, AuthState, AuthAction } from './reducer';

const AuthStateContext    = React.createContext<AuthState>(initialState);
const AuthDispatchContext = React.createContext<React.Dispatch<AuthAction>>(() => null);

export const useAuthorization = () : AuthState =>
{
    const context = useContext(AuthStateContext);
    return context;
};

export const useAuthorizationDispatch = () : React.Dispatch<AuthAction> =>
{
    const context = useContext(AuthDispatchContext);
    return context;
};

export const AuthProvider: React.FunctionComponent = ({ children }) => 
{
    const [ user, dispatch ] = useReducer<React.Reducer<AuthState, AuthAction>>(AuthReducer, initialState);

    return (
        <AuthStateContext.Provider value={user}>
            <AuthDispatchContext.Provider value={dispatch}>
                {children}
            </AuthDispatchContext.Provider>
        </AuthStateContext.Provider>
    );
};